import { BOOKING_GA_CATEGORIES, BookingPathKeys } from './paths';

export const PHONE_VERIFICATION_GA_CATEGORY =
    BOOKING_GA_CATEGORIES[BookingPathKeys.phoneVerificationPath];

export const GaActionText = {
    selectPhoneNumber: 'Select phone number input',
    clickTextMe: 'Clicked text me button',
    clickCallMe: 'Clicked call me button',
    selectPin: 'Select pin code input',
    clickVerifyPin: 'Clicked verify pin button',
    clickEditPhoneNumber: 'Clicked edit phone number link',
    clickLetsTryThisAgain: 'Clicked lets try this again link',
    madeItToPin: 'Made it to pin',
};

export const PHONE_VERIFICATION_MODE = {
    ENTRY_MODE: 'ENTRY_MODE',
    VERIFY_MODE: 'VERIFY_MODE',
};

export const PhoneVerificationErrors = {
    PhoneAlreadyVerified: 'PHONE_ALREADY_VERIFIED',
    InvalidPhoneNumber: 'INVALID_PHONE_NUMBER',
};

export const PHONE_VERIFICATION_ROOT_KEY = 'phoneVerificationPage';
export const SCHEDULING_ROOT_KEY = 'scheduling';
export const PHONE_ROOT_KEY = 'phone';

export const BookingErrorCodes = {
    General: 'GENERAL',
    MaxAppointmentsReached: 'MAX_APPOINTMENTS_EXCEPTION',
    AlreadyRescheduledException: 'ALREADY_RESCHEDULED_EXCEPTION',
    TimeslotGoneException: 'TIMESLOT_GONE_EXCEPTION',
};

export const BookingFieldFailureCodes = {
    phoneNotVerified: 'PhoneIsVerifiedFailure',
};
